import { useState } from "react";
import { LogIn, LogOut, Loader2 } from "lucide-react";

interface CheckButtonProps {
  isCheckedIn: boolean;
  onToggle: () => void;
  isLoading?: boolean;
}

const CheckButton = ({ isCheckedIn, onToggle, isLoading = false }: CheckButtonProps) => {
  const [isPressed, setIsPressed] = useState(false);

  const handlePress = () => {
    if (isLoading) return;

    setIsPressed(true);
    onToggle();
    setTimeout(() => setIsPressed(false), 150);
  };

  return (
    <div className="flex justify-center py-8">
      <button
        onClick={handlePress}
        disabled={isLoading}
        className={`
          relative w-40 h-40 rounded-full bg-card shadow-check-button
          border-4 border-primary/20 transition-all duration-300 ease-smooth
          ${isLoading 
            ? 'opacity-70 cursor-not-allowed' 
            : isPressed 
              ? 'scale-95 shadow-sm' 
              : 'hover:scale-105 active:scale-95 cursor-pointer'
          }
          group
        `}
      >
        {/* Outer ring animation */}
        <div className={`absolute inset-2 rounded-full border-2 border-primary/30 ${isLoading ? 'animate-spin' : 'animate-pulse'}`} />
        
        {/* Inner button */}
        <div className={`absolute inset-4 rounded-full bg-primary flex items-center justify-center transition-colors ${!isLoading && 'group-hover:bg-primary-light'}`}>
          {isLoading ? (
            <Loader2 className="w-8 h-8 text-primary-foreground animate-spin" />
          ) : isCheckedIn ? (
            <LogOut className="w-8 h-8 text-primary-foreground transform translate-x-0.5" />
          ) : (
            <LogIn className="w-8 h-8 text-primary-foreground transform -translate-x-0.5" />
          )}
        </div>
        
        {/* Button label */}
        <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 whitespace-nowrap">
          <span className="text-sm font-medium text-time-display">
            {isLoading
              ? "Processing..."
              : isCheckedIn
                ? "Check Out"
                : "Check In"
            }
          </span>
        </div>
      </button>
    </div>
  );
};

export default CheckButton;